import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const PlayIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path d="M3.33876 20C3.00508 19.9994 2.67731 19.9119 2.38768 19.7462C1.73551 19.3766 1.33008 18.6592 1.33008 17.8804V2.11965C1.33008 1.33868 1.73551 0.623462 2.38768 0.253899C2.6842 0.0834848 3.02106 -0.00415108 3.36303 0.000151107C3.70501 0.0044533 4.03955 0.100536 4.33169 0.278356L17.8017 8.34136C18.0825 8.51739 18.3139 8.76183 18.4743 9.05176C18.6347 9.34169 18.7189 9.66761 18.7189 9.99896C18.7189 10.3303 18.6347 10.6562 18.4743 10.9462C18.3139 11.2361 18.0825 11.4805 17.8017 11.6566L4.32952 19.7217C4.03055 19.9025 3.68812 19.9987 3.33876 20Z" />
  </SvgIcon>
);
